export default () => {
    let zoom = 1;
    let widthVideo;
    let textMargin;

    zoom = (window.innerHeight < 500 ? 500 : window.innerHeight)  * zoom / 700;
    widthVideo = (window.innerHeight  < 500 ? 500 : window.innerHeight) / 1.85 > 370 ? (window.innerHeight  < 500 ? 500 : window.innerHeight) / 1.85 : 370;
    textMargin = `-2000px`

    document.documentElement.style.setProperty('--widthVideo', `${widthVideo}px`)
    document.documentElement.style.setProperty('--svgWidth', `${zoom > 1 ? 1 : zoom }`)
    document.documentElement.style.setProperty('--textMargin', `${textMargin}`)
}